import api from "../api";
/* eslint-disable */
export default {
    namespaced: true,
    state: {
        governates: [],
        searchResults: [],
        rideDetails: [],
        loading: false,
        error: null,
        searchParameters: null, // Store last search parameters
    },
    getters: {
        getGovernates(state) {
            return Array.isArray(state.governates) ? state.governates : [];
        },
        getSearchResults(state) {
            return Array.isArray(state.searchResults) ? state.searchResults : [];
        },
        getRideDetails(state) {
            return Array.isArray(state.rideDetails) ? state.rideDetails : [];
        },
        isLoading(state) {
            return state.loading;
        },
        getError(state) {
            return state.error;
        },
        getSearchParameters(state) {
            return state.searchParameters;
        },
    },
    mutations: {
        SetGovernates(state, data) {
            state.governates = [];
            state.governates = data;
        },
        SetSearchResults(state, data) {
            state.searchResults = [];
            // get the pichup stop and drop off stop from stops array as the first and last stop
            state.searchResults = data.map(item => ({
                ...item,
                rideDate: new Date(item.rideDate), // Convert string to Date object for filtering
                pickupStop: item.stops[0],
                dropOffStop: item.stops[item.stops.length - 1]
            }));
        },
        SetRideDetails(state, data) {
            state.rideDetails = [];
            state.rideDetails = data;
        },
        SetLoading(state, loading) {
            state.loading = loading;
        },
        SetError(state, error) {
            state.error = error;
        },
        ClearError(state) {
            state.error = null;
        },
        SetSearchParameters(state, parameters) {
            state.searchParameters = parameters;
        },
        ClearSearchParameters(state) {
            state.searchParameters = null;
        },
    },
    actions: {
        // Action to call GetGovernates API function
        async fetchGovernates({ commit }) {
            commit('SetLoading', true);
            commit('ClearError');

            try {
                const response = await api().post('search/get_governates', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
                    },
                });

                if (response.data.status === "Success") {
                    commit('SetGovernates', response.data.data || response.data.Data || []);
                    return Promise.resolve(response.data);
                } else {
                    commit('SetError', response.data.Message || 'Failed to fetch governates');
                    return Promise.reject(response.data.Message);
                }
            } catch (error) {
                commit('SetError', error.message || 'An error occurred while fetching governates');
                return Promise.reject(error);
            } finally {
                commit('SetLoading', false);
            }
        },

        // Action to call SearchForRidesByGovernorate API function
        async searchForRidesByGovernorate({ commit }, searchRequest) {
            commit('SetLoading', true);
            commit('ClearError');
            
            // Store search parameters for later use
            commit('SetSearchParameters', searchRequest);

            try {
                const response = await api().post('search/search-for-rides', searchRequest, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data.status === "Success") {
                    commit('SetSearchResults', response.data.data);
                    return Promise.resolve(response.data);
                } else {
                    commit('SetError', response.data.Message || 'Failed to search for rides');
                    return Promise.reject(response.data.Message);
                }
            } catch (error) {
                commit('SetError', error.message || 'An error occurred while searching for rides');
                return Promise.reject(error);
            } finally {
                commit('SetLoading', false);
            }
        },

        // Action to repeat last search
        async repeatLastSearch({ state, dispatch }) {
            if (state.searchParameters) {
                return dispatch('searchForRidesByGovernorate', state.searchParameters);
            } else {
                return Promise.reject('No previous search parameters found');
            }
        },

        async getRideDetails({ commit }, { rideId, busTypeId }) {
            commit('SetLoading', true);
            commit('ClearError');

            try {
                const response = await api().post('search/get_ride_details', { rideId, busTypeId }, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("JwtToken")}`,
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data.status === "Success") {
                    commit('SetRideDetails', response.data.data);
                    return Promise.resolve(response.data);
                } else {
                    commit('SetError', response.data.Message || 'Failed to get ride details');
                    return Promise.reject(response.data.Message);
                }
            } catch (error) {
                commit('SetError', error.message || 'An error occurred while getting ride details');
                return Promise.reject(error);
            } finally {
                commit('SetLoading', false);
            }
        },

        // Helper action to clear search results
        clearSearchResults({ commit }) {
            commit('SetSearchResults', []);
        },

        // Helper action to clear error
        clearError({ commit }) {
            commit('ClearError');
        },

        // Helper action to clear search parameters
        clearSearchParameters({ commit }) {
            commit('ClearSearchParameters');
        },
    },
};